import React from "react";
import "./WhyUsPageStyle.scss";
import { bannerWhyUsTextContent } from "./constant";
import MainLayout from "../../components/MainLayout";
import SingleBannerSection from "components/SingleBannerSection";
import SlotGamesDevelopmentSuperiorSection from "components/SlotGamesDevelopmentSuperiorSection";
import OurVisionSectionSection from "components/OurVisionSection";
import OurMissionSection from "components/OurMissionSection";
import IndustriesWeWorkSection from "components/IndustriesWeWorkSection";
import GeographicalCoverageSection from "components/GeographicalCoverageSection";
import SlotGamesSection from "components/SlotGamesSection";
import ContactUsSection from "components/ContactUsSection";

const WhyUsPage = () => {
  return (
    <MainLayout>
      <div className="slot-games-page">
        {bannerWhyUsTextContent.content.map((item, index) => (
          <SingleBannerSection
            key={index}
            bannerTitleText={item.titleText}
            bannerParaText={item.paraText}
            btnText={item.btnText}
            bannerImageSrcContact={item.imageSrcContact}
            bannerImageSrc={item.imageSrc}
          />
        ))}
        <SlotGamesDevelopmentSuperiorSection />
        <OurVisionSectionSection />
        <OurMissionSection />
        <IndustriesWeWorkSection />
        <GeographicalCoverageSection />
        {/* <SlotGamesSection /> */}
        <ContactUsSection />
      </div>
    </MainLayout>
  );
};

export default WhyUsPage;
